<template>
    <div id="public-container">
        <router-view 
            class="main"
            @alertMsg="alertMsg"
        ></router-view>

        <!-- Footer -->
        <app-footer/>

        <template v-if="alertMsgs">
            <Alert
                :type="alertMsgs.type"
                :key="alertMsgs.key"
                class="alert"
            >
                {{ alertMsgs.message }}
            </Alert>
        </template>
    </div>
</template>

<script>
import Alert from '@/components/Alert';
import AppFooter from '@/layout/AppFooter.vue';

export default {
    name: 'public',
    data() {
        return {
            route: this.$route.name,
            alertMsgs: undefined
        }
    },
    watch: {
        '$route'() {
            this.alertMsgs = undefined;
        }
    },
    methods: {
        alertMsg(msg) {
            this.alertMsgs = msg;
        }
    },
    components: {
        Alert,
        AppFooter
    }
}
</script>

<style scoped>
/* ----------------------------------- */
/* ------------ Container ------------ */
/* ----------------------------------- */
#public-container {
    width: 100%;
}
#public-container .main {
    height: calc(100vh - 50pt);
    overflow: scroll;
}
#public-container  .alert {
    position: fixed;
}
</style>